import GlobalSnackBar from './GlobalSnackBar';
export default GlobalSnackBar;
